import { DirectLine, ConnectionStatus } from "botframework-directlinejs";
import React, { Component, Fragment } from "react";
import { IntlProvider } from "react-intl";
import ChatBubble from "./ChatBubble";
import ChatWindow from "./ChatWindow";
import SildeBubble from "./ChatBubbleComponent/SildeBubble";
import StartSalesforceChatSuccessModal from "./ChatComponent/StartSalesforceChatSuccessModal";
import CaseFormSuccessModal from "./ChatComponent/CaseFormSuccessModal";
import AppLocale from "./lang";
import getChatStore, {
  sendChatStore,
  sendHistoryToZendesk,
  sendHistoryToGenesysPureCloud,
  getChatHistoryForAgent,
} from "./ChatStore";
import * as uuid from "uuid/v4";
import * as LivechatSDK from "@livechat/livechat-visitor-sdk";
import * as zChat from "zendesk-chat-sdk";
import ChatAppExtensions from "./Extensions/ChatAppExtensions";
import ChatWindowParticipantTagger from "./ChatWindowParticipantTagger";
import { trackAppInsightsEvent } from "./helpers/AppInsights";
import { Client as ConversationsClient } from "@twilio/conversations";
import {
  JsonHubProtocol,
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
const SIGNALR_URL = process.env.REACT_APP_SIGNALR_URL;
const publicIp = require("public-ip");
const TOKEN_GEN_URL = process.env.REACT_APP_API_URL + "/getToken";
const GROUP_URL = process.env.REACT_APP_API_URL + "/group";
const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_API_URL + "/twilio-token";
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_API_URL + "/endTwilioConversation";
const PAGE_VISIT_URL = process.env.REACT_APP_API_URL + "/pageLoaded";
const PROPERTIES_URL = process.env.REACT_APP_API_URL + "/properties";
const BOT_CLICKS = process.env.REACT_APP_API_URL + "/botclick";
const MEWS_API = process.env.REACT_APP_API_URL + "/mews";
const ADD_MESSAGE_THREAD = process.env.REACT_APP_API_URL + "/threadId";
const MS_REFRESH_URL =
  "https://directline.botframework.com/v3/directline/tokens/refresh";
const LIVECHAT_LICENSE = 9036740;
const LIVECHAT_GROUP = 72;
const BMB_INTEGRATION =
  process.env.REACT_APP_BFF_API + "/public/integrations/helpcenter";
/**
 * Main chat app, runs with the page
 */
export default class ChatApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatBindings: {
        startLivechat: this.startLivechat.bind(this),
        startTwiliochat: this.startTwiliochat.bind(this),
        startSignalRchat: this.startSignalRchat.bind(this),
        endTwilio: this.endTwilio.bind(this),
        endSignalRChat: this.endSignalRChat.bind(this),
        setAgentId: this.setAgentId.bind(this),
        enableChat: this.enableChat.bind(this),
        disableChat: this.disableChat.bind(this),
        getState: this.getState.bind(this),
        setInLivechat: this.setInLivechat.bind(this),
        isInLivechat: this.isInLivechat.bind(this),
        isInTwiliochat: this.isInTwiliochat.bind(this),
        isInSignalRchat: this.isInSignalRchat.bind(this),
        sendTwilioTypingIndicator: this.sendTwilioTypingIndicator.bind(this),
        sendZendeskTypingIndicator: this.sendZendeskTypingIndicator.bind(this),
        sendSignalRTypingIndicator: this.sendSignalRTypingIndicator.bind(this),
        setInTwiliochat: this.setInTwiliochat.bind(this),
        setInSignalRchat: this.setInSignalRchat.bind(this),
        getChatState: this.getChatState.bind(this),
        setExtension: this.setExtension.bind(this),
        setAvailblity: this.setAvailblity.bind(this),
        hideTypingTextBox: this.hideTypingTextBox.bind(this),
        showTypingTextBox: this.showTypingTextBox.bind(this),
        setConnectionStatus: this.setConnectionStatus.bind(this),
        setInactivePopupOne: this.setInactivePopupOne.bind(this),
        setInactivePopupTwo: this.setInactivePopupTwo.bind(this),
        closeInactivePopupOne: this.closeInactivePopupOne.bind(this),
        hideTextCount: this.hideTextCount.bind(this),
        startZenDeskChat: this.startZenDeskChat.bind(this),
        isInZendeskChat: this.isInZendeskChat.bind(this),
        setPropertyPopUp: this.setPropertyPopUp.bind(this),
        ChangeBotLanguage: this.ChangeBotLanguage.bind(this),
        ChangePropertyId: this.ChangePropertyId.bind(this),
        startMewsChat: this.startMewsChat.bind(this),
        startGenesysPureCloudChat: this.startGenesysPureCloudChat.bind(this),
        startAWSConnectChat: this.startAWSConnectChat.bind(this),
        isInGenesysPureCloudChat: this.isInGenesysPureCloudChat.bind(this),
        isInAWSConnectChat: this.isInAWSConnectChat.bind(this),
        isInMewsChat: this.isInMewsChat.bind(this),
        genesysPureCloudChatSettings:
          this.genesysPureCloudChatSettings.bind(this),
        amazonConnectTokenSettings: this.amazonConnectTokenSettings.bind(this),
        mewsChatSettings: this.mewsChatSettings.bind(this),
        getExtension: (extensionName) => this.state.extensions[extensionName],
        makePayment: (details, callback) => {
          this.setState({
            makePayment: {
              details,
              callback,
              close: () => {
                this.setState({ makePayment: undefined });
              },
            },
          });
        },
        setWebchatJoined: (joined) => {
          this.setState({ isWebChatJoined: joined });
        },
        getRoomTypes: (details) => {
          this.setState({
            getRoomTypes: {
              details,
              reinit: true,
            },
          });
          var booking = this.state.bookingApp;
          booking.open = true;

          this.setState({
            bookingApp: booking,
          });
        },
        getGID: () => {
          return this.props.gid;
        },
        getIID: () => {
          return this.props.iid;
        },
        getPID: () => {
          return this.props.pid;
        },
        getAgentId: () => {
          return this.state.agentId;
        },
        getBotSettings: () => {
          return this.state.botSettings;
        },
        getLiveChatSettings: () => {
          return this.state.liveChatSettings;
        },
        getDirectLineConversation: () => {
          return this.state.directline.conversationId;
        },
        isCheckedAvailability: false,
        hideRoomDetail: false,

        showBookingForm: (available, hideRoom) => {
          this.setState({
            isCheckedAvailability: available,
            hideRoomDetail: hideRoom,
          });
        },
        scrollChat: this.scrollChat,
        addScrollEvent: this.addScrollEvent,
        showHideMoveToTop: this.showHideMoveToTop.bind(this),
        setWebchatJoined: (joined) => {
          this.setState({ isWebChatJoined: joined });
        },
      },
    };
    const iid = props.iid;
    const accountIdSuffix =
      props.accountId && props.accountId !== null && props.accountId !== ""
        ? "-" + props.accountId
        : "";
    const contactIdSuffix =
      props.contactId && props.contactId !== null && props.contactId !== ""
        ? "-" + props.contactId
        : "";
    const visitorScopeSuffix = accountIdSuffix + contactIdSuffix;

    const lStore = {
      // per-integration constants used for localstorage identifiers
      OPENED: iid + "-opened",
      IDENTITY: iid + "-identity" + visitorScopeSuffix,
      CHAT_STATE: iid + "-chatstate" + visitorScopeSuffix,
      CREDENTIALS: iid + "-credentials",
      LIVECHAT_STARTED: iid + "-livechatStarted",
      GENESYS_CLOUD_STARTED: iid + "-genesyscloudchatStarted",
      AWS_CONNECT_STARTED: iid + "-awsconnectStarted",
      AWS_CONNECT_THREAD: iid + "-awsconnectThreadId",
      AWS_CONNECT_REGION: iid + "-awsconnectRegion",
      MEWS_CHAT_STARTED: iid + "-mewschatStarted",
      MEWS_THREAD: iid + "-mewsThreadId",
      COOKIES: iid + "-cookies",
      PROPERTYID: iid + "-property",
      PROPERTYNAME: iid + "-propertyName",
      EXTENSIONS: iid + "-extensions",
      LANGUAGE: iid + "-language",
      DOMAIN: iid + "-domain",
      BOTCLICK: iid + "-botclick",
      LIVECHATMESSAGESTAMP: iid + "-livechatmessagetimestamp",
      LIVECHATCLIENT: iid + "-livechatclient",
      VISITORDETAILS: iid + "-visitor",
      ZENDESKGROUP: iid + "-zendeskgroup",
      PERCHAT_FILL: iid + "-prechatfill",
    };

    let loadedExtensions;
    try {
      loadedExtensions = JSON.parse(localStorage.getItem(lStore.EXTENSIONS));
    } catch {}
    if (!loadedExtensions) {
      loadedExtensions = {};
    }
    localStorage.setItem(lStore.LANGUAGE, this.props.language);
    this.state = {
      lStore: lStore,
      lang: this.props.language || "en",
      opened:
        this.props.defaultOpen ||
        (this.props.mobile == "false" &&
          localStorage.getItem(lStore.OPENED) === "open"),
      messages: [],
      directline: undefined,
      webSpeechPonyfill: undefined,
      started: false,
      isWebChatJoined: false,
      chatBindings: this.state.chatBindings,
      inputEnabled: false,
      inLiveChat: false,
      livechat: undefined,
      loadingLivechat: false,
      makePayment: false,
      getRoomTypes: undefined,
      createChatSessionStartUp: false,
      animation: {
        bubbleToFadeIn: true,
      },
      integrationSettings: undefined,
      blockChatbot: false,
      extensions: {
        ...loadedExtensions,
        _api: ChatAppExtensions.getAPI(
          this,
          this.props,
          this.state.isSuggestBot,
        ),
      },
      connectionError: false,
      visitorPopUp: false,
      inTwilioChat: false,
      inSignalRChat: false,
      twiliochat: undefined,
      signalrchat: undefined,
      twilioAccessToken: undefined,
      twilioChatId: undefined,
      signalRChatId: undefined,
      disabledChatbot: false,
      inactivePopupOne: false,
      inactivePopupTwo: false,
      moveTop: false,
      persistentMenu: null,
      persistentMenuEnabled: false,
      agentId: "",
      resize: false,
      botclick: false,
      inZenDesk: false,
      inMewsChat: false,
      mewsChatSettings: undefined,
      zendesk: undefined,
      liveChatSettings: undefined,
      zendeskDepartment: "",
      zendeskChatNew: true,
      availblity: undefined,
      open_ZChatfeedback_popup: false,
      property_popup: false,
      bot_restart: false,
      inGenesysPureCloudChat: false,
      genesysPureCloudSettings: undefined,
      messengerSettings: "",
      inAwsConnect: false,
      amazonConnectToken: undefined,
      groupData: null,
      isSuggestBot: false,
      isRestartcon: false,
      micIconSetting: null,
      prechatdata: null,
      messengerTheme: null,
      websiteFontName: "",
      websiteFontLink: "",
      isError: false,
      showTransferModal: false,
      transferCaseId: "",
      transferCaseNumber: "",
      showCaseFormSuccessModal: false,
      caseFormSuccessCaseId: "",
      caseFormSuccessCaseNumber: "",
    };

    if (accountIdSuffix || contactIdSuffix) {
      const chatStateName = iid + "-chatstate" + visitorScopeSuffix;
      let forcedNewStoredState = false;
      const localStorageKeys = Object.keys(localStorage);
      for (const key of localStorageKeys) {
        if (key.startsWith(iid + "-chatstate-") && key !== chatStateName) {
          localStorage.removeItem(key);
          forcedNewStoredState = true;
        }
      }
      if (forcedNewStoredState) {
        this.end();
      }
    }

    // getChatStore needs state.lStore to be set first for it to work
    this.state.store = getChatStore(this.state.chatBindings);

    this.state.bookingApp = {
      open: false,
      callbacks: {
        getStore: () => {
          return this.state.store;
        },
      },
      chatBindings: this.state.chatBindings,
      lStore: lStore,
    };

    // Tell parent iframe opened state
    this.state.opened
      ? this.postMessage("chatbotwindowOpen")
      : this.postMessage("chatbotwindowClose");

    this.addThreadId = async (messageThreadId) => {
      const req = await fetch(`${ADD_MESSAGE_THREAD}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.state.directline.conversationId,
          groupId: this.props.gid,
          messageThreadId: messageThreadId,
        }),
      });
    };

    this.sendMessageRetryTimers = new Set();
    this.directlineSendGuards = new Map();
    this.windowMessageHandler = this.windowMessage.bind(this);

    // Listen to messages
    window.addEventListener("message", this.windowMessageHandler, false);
  }

  /**
   * Start conversation on mount
   */
  componentDidMount() {
    if (!this.state.started) {
      this.setState({ started: true });

      if (this.props.openChatWindow === true) {
        this.opened();
        this.postMessage("chatbotwindowOpen");
      }
      this.startConversation(true);
    }

    // if (this.props.messenger === true) {
    //   this.setState({ opened: false });
    // }
    if (localStorage.getItem(this.state.lStore.OPENED) === "open") {
      this.postMessage("openMessengerBotClickAvtar");
    }

    // Fetching group data
  }

  componentWillUnmount() {
    if (this.windowMessageHandler) {
      window.removeEventListener("message", this.windowMessageHandler, false);
    }
    if (this.sendMessageRetryTimers) {
      this.sendMessageRetryTimers.forEach((timerId) => clearTimeout(timerId));
      this.sendMessageRetryTimers.clear();
    }
    if (this.directlineSendGuards) {
      this.directlineSendGuards.clear();
    }
  }

  /**
   * Listens to component changes, sends opened status to parent frame for resizing
   * (frame on client site must shrink to not cover content when chat minimised)
   */
  componentDidUpdate(prevProps, prevState) {
    if (prevState.opened !== this.state.opened) {
      this.state.opened
        ? this.postMessage("chatbotwindowOpen")
        : this.postMessage("chatbotwindowClose");
    }
  }

  /**
   * Handles messages from the window (i.e. from the containing iframe)
   */
  windowMessage(event) {
    if (event.data.toString().startsWith("lang_code:")) {
      this.setState({ lang: event.data.substring("10"), autoDetect: false });
    }

    if (event.data.toString().startsWith("auth_token:")) {
      if (event.data.substring("11") !== "") {
        // console.log("33", event.data.substring("11"));
        this.setState({ bearerToken: event.data.substring("11") });
        this.state.store.dispatch({
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "webchat/token-update",
            value: {
              bearerToken: event.data.substring("11"),
            },
          },
        });
      }
    }

    if (event.data.toString().startsWith("msg_property:")) {
      var prodata = JSON.parse(event.data.substring("13"));
      if (prodata === null) {
        console.log(this.state.bookingApp.properties);
        //this.selectProperty(this.state.bookingApp.properties)
      } else {
        this.selectProperty(prodata);
      }
    }

    if (event.data.toString().startsWith("msg_welcome:")) {
      var prodata = JSON.parse(event.data.substring("13"));
      console.log("prodata", prodata);
      if (prodata === null) {
        console.log(this.state.bookingApp.properties);
        //this.selectProperty(this.state.bookingApp.properties)
      } else {
        this.sendWelcomeMessage(prodata);
      }
    }

    if (!this.state.opened && event.data === "chatwindowOpened") {
      this.setState({ opened: true });
    }
    if (event.data === "chatwindowOpenedInMsg") {
      this.opened();
    }
    if (event.data === "restartchat") {
      this.setState({ isRestartcon: true });
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("chatwindowSuggestOpenedInMsg:")
    ) {
      var data = JSON.parse(event.data.substring(29));
      this.opened();
      this.setState({ isSuggestBot: true, micIconSetting: data });
    }
    if (event.data === "openMessengerChatWindow") {
      this.setState({ opened: true });
    }
    if (event.data === "bot_restart") {
      this.setState({ bot_restart: true });
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("prechat-input:")
    ) {
      var data = JSON.parse(
        event.data.substring(14).replace("contactid", "contactId"),
      );
      this.setState({ prechatdata: data });
    }

    //buutonColorInMsg

    if (
      typeof event.data === "string" &&
      event.data.startsWith("buttonColorInMsg:")
    ) {
      // console.log("eventdata", event.data);
      var data = JSON.parse(event.data.substring(17));
      if (
        data.micIconSetting !== undefined &&
        data.micIconSetting !== null &&
        data.micIconSetting.isMicIcon === true &&
        data.isHeader === true &&
        this.state.webSpeechPonyfill === undefined
      ) {
        this.speechConversation();
      }
      this.setState({
        messengerSettings: data.buttonColorInMsg,
        micIconSetting: data.micIconSetting,
      });
    }

    // cookies
    if (
      typeof event.data === "string" &&
      event.data.startsWith("cookiesContent:")
    ) {
      var load = JSON.parse(event.data.substring(15));

      this.setState({ cookiesData: load });
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("update-styling:")
    ) {
      let payload = event.data.substr(15);
      this.setState({ integrationSettings: JSON.parse(payload) });
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("nudge_message:")
    ) {
      console.log("nudge_message", event.data.replace("nudge_message:", ""));
      this.sendMessageDirectline(event.data.replace("nudge_message:", ""));
    }
    if (typeof event.data === "string" && event.data.startsWith("message:")) {
      this.opened();
      console.log("message", event.data.replace("message:", ""));
      this.sendMessageDirectline(event.data.replace("message:", ""));
    }
    if (
      typeof event.data === "string" &&
      event.data.startsWith("messengerLang:")
    ) {
      this.setState({ lang: event.data.substr(14) });
    }

    if (event.data.toString().startsWith("openInternalLink:")) {
      var prodata = JSON.parse(event.data.substring("17"));
      this.state.store.dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/openWebView",
          value: {
            url: prodata.url,
            title: "",
            mode: "Normal",
            largeWindowHideHeader: false,
          },
        },
      });
    }
    // messenger theme
    if (event.data.toString().startsWith("chatwindowSuggestOpenedInMsg:")) {
      try {
        const payload = JSON.parse(event.data.substring(29));
        const theme = payload.theme;
        if (theme) {
          this.setState({
            messengerTheme: theme,
          });
        }
      } catch (e) {
        console.error("Failed to parse theme message", e);
      }
    }
  }

  /**
   * Scrolls chat to bottom, achieves this slightly messily by selecting using CSS selectors
   */

  sendMessageDirectline(message, attempt = 0, hasRestarted = false, requestId) {
    const maxAttempts = 10;
    const retryDelayMs = 2000;
    const guardId = requestId || `${Date.now()}-${Math.random()}`;

    if (!this.directlineSendGuards.has(guardId)) {
      this.directlineSendGuards.set(guardId, { sent: false });
    }

    const guard = this.directlineSendGuards.get(guardId);

    const clearGuard = () => {
      this.directlineSendGuards.delete(guardId);
    };

    const scheduleRetry = () => {
      if (attempt >= maxAttempts) {
        console.warn("DirectLine message dropped after max retries", {
          message,
          attempts: attempt,
        });
        clearGuard();
        return;
      }

      let nextHasRestarted = hasRestarted;
      if (!nextHasRestarted) {
        nextHasRestarted = true;
        this.startConversation(true);
      }

      const timerId = setTimeout(() => {
        this.sendMessageRetryTimers.delete(timerId);
        this.sendMessageDirectline(
          message,
          attempt + 1,
          nextHasRestarted,
          guardId,
        );
      }, retryDelayMs);

      this.sendMessageRetryTimers.add(timerId);
    };

    if (!this.state.directline || !this.state.store) {
      scheduleRetry();
      return;
    }

    let subscription;
    try {
      subscription = this.state.directline.connectionStatus$.subscribe(
        (status) => {
          if (subscription && typeof subscription.unsubscribe === "function") {
            subscription.unsubscribe();
          }

          console.log("DirectLine connection status:", status);
          switch (status) {
            case ConnectionStatus.Online:
              if (guard && guard.sent) {
                console.log(
                  "DirectLine message already sent, skipping duplicate",
                  {
                    message,
                    guardId,
                  },
                );
                return;
              }
              guard.sent = true;
              console.log("DirectLine connection online now", message);
              this.state.store.dispatch({
                type: "WEB_CHAT/SEND_MESSAGE",
                payload: {
                  text: message,
                },
              });
              clearGuard();
              break;
            case ConnectionStatus.FailedToConnect:
            case ConnectionStatus.ExpiredToken:
            case ConnectionStatus.Ended:
              console.warn("DirectLine unavailable, skipping send", {
                status,
                message,
              });
              clearGuard();
              break;
            default:
              scheduleRetry();
          }
        },
        (error) => {
          if (subscription && typeof subscription.unsubscribe === "function") {
            subscription.unsubscribe();
          }
          console.log("Error observing DirectLine connection status", error);
          scheduleRetry();
        },
      );
    } catch (e) {
      console.log("Error subscribing to DirectLine connection status", e);
      scheduleRetry();
    }
  }

  scrollChat() {
    var els = document.getElementsByClassName("css-y1c0xs");
    for (var el of els) {
      if (el.classList.contains("css-ca0rlf")) {
        el.scrollTop = el.scrollHeight;
      }
    }
  }

  addScrollEvent() {
    var els1 = document.getElementsByClassName(
      "webchat__basic-transcript__scrollable",
    );
    if (els1.length > 0) {
      els1[0].addEventListener("scroll", () => {
        if (els1[0].scrollTop > 100) {
          this.showHideMoveToTop(true);
        } else {
          this.showHideMoveToTop(false);
        }
      });
      if (els1[0].scrollTop > 100) {
        this.showHideMoveToTop(true);
      } else {
        this.showHideMoveToTop(false);
      }
    }
  }

  showHideMoveToTop(show) {
    this.setState({ moveTop: show });
  }

  hideTypingTextBox() {
    // this.setState({ moveTop: true });
    var els = document.getElementsByClassName("main");
    // console.log(els.length);
    if (els.length === 0) {
      const hideInterval = setInterval(function () {
        var els1 = document.getElementsByClassName("main");
        // console.log(els1.length);
        if (els1.length > 0) {
          clearInterval(hideInterval);
          for (var el of els1) {
            if (el.classList.contains("main")) {
              el.style.display = "none";
            }
          }
        }
      }, 1500);
      setTimeout(function () {
        clearInterval(hideInterval);
      }, 15000);
    } else {
      if (els.length > 0) {
        for (var el of els) {
          if (el.classList.contains("main")) {
            el.style.display = "none";
          }
        }
      }
    }
  }

  hideTextCount() {
    var els = document.getElementById("span-count");
    if (els !== null) {
      els.innerText = "";
    }
  }

  showTypingTextBox() {
    var els = document.getElementsByClassName("main");
    if (els.length > 0) {
      for (var el of els) {
        if (el.classList.contains("main")) {
          el.style.display = "flex";
        }
      }
    }
  }

  setAvailblity(payload) {
    this.setState({ availblity: payload });
  }

  setPropertyPopUp(payLoad) {
    this.setState({ property_popup: payLoad });
  }

  ChangeBotLanguage(detectedLang, autoDetect) {
    this.postMessage("langDetect:" + detectedLang);
    this.setState({ lang: detectedLang, autoDetect: autoDetect });
  }
  ChangePropertyId(pid) {
    localStorage.setItem(this.state.lStore.PROPERTYID, pid);
  }

  setExtension(extensionName, payload) {
    let extensions = {
      ...this.state.extensions,
      [extensionName]: payload,
    };
    this.setState({ extensions });

    localStorage.setItem(
      this.state.lStore.EXTENSIONS,
      JSON.stringify(extensions),
    );
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  sendWelcomeMessage = (elem) => {
    this.state.bookingApp.selectedPid = elem;
    this.forceUpdate();
    localStorage.setItem(this.state.bookingApp.lStore.PROPERTYID, elem.value);
    localStorage.setItem(this.state.bookingApp.lStore.PROPERTYNAME, elem.label);
    this.state.bookingApp.callbacks.getStore().dispatch({
      type: "WEB_CHAT/SEND_EVENT",
      payload: {
        name: "webchat/welcome",
        value: {
          pid: elem.value,
          pname: elem.label,
        },
      },
    });
  };

  selectProperty = (elem) => {
    this.state.bookingApp.selectedPid = elem;
    this.forceUpdate();
    localStorage.setItem(this.state.bookingApp.lStore.PROPERTYID, elem.value);
    localStorage.setItem(this.state.bookingApp.lStore.PROPERTYNAME, elem.label);
    if (!this.state.isWebChatJoined) {
      this.state.bookingApp.callbacks.getStore().dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/join",
          value: {
            language: "en-US",
            gid: this.props.gid,
            iid: this.props.iid,
            pid: elem.value,
            vid: this.state.vid,
            sid: this.state.sid,
            lang: this.state.lang,
            pname: elem.label,
            currencyCode: this.state.currencyCode,
          },
        },
      });
    } else {
      this.state.bookingApp.callbacks.getStore().dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "webchat/update",
          value: {
            pid: elem.value,
            pname: elem.label,
          },
        },
      });
    }
  };
  /**
   * Registers that the user visited the page, manages visitor ID/session ID
   * vid/sid are persisted between sessions, sid is changed if the conversation ID expires
   */
  async registerPageLoad(botConversationId) {
    let ip;
    try {
      ip = await publicIp.v4();
    } catch (error) {
      ip = undefined;
      trackAppInsightsEvent(
        "chat_page_load_ip_lookup_failed",
        {
          errorMessage: error && error.message ? error.message : String(error),
          botConversationId: botConversationId,
        },
        this.props.gid,
      );
      console.warn("Could not resolve visitor IP.", error);
    }
    console.log("pid", this.props.pid);
    var user = {
      iid: this.props.iid,
      gid: this.props.gid,
      pid: this.props.pid,
      vid: undefined,
      sid: undefined,
      locale: "en-US",
      parent_location: this.props.parent_location,
      parent_referrer: this.props.parent_referrer,
      page_title: this.props.parent_title,
      ip: ip,
      botConversationId: botConversationId,
    };

    var identity = localStorage.getItem(this.state.lStore.IDENTITY);
    if (identity) {
      try {
        identity = JSON.parse(identity);
        user.vid = identity.vid;
        user.sid = identity.sid;
      } catch (e) {
        user.vid = undefined;
        user.sid = undefined;
      }
    }

    let result;

    try {
      const req = await fetch(PAGE_VISIT_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: user,
        }),
      });

      if (!req.ok) {
        console.error("API failed with status:", req.status);
        trackAppInsightsEvent(
          "chat_page_load_failed",
          {
            reason: "http_error",
            httpStatus: req.status,
            vid: user.vid || "",
            sid: user.sid || "",
            botConversationId: botConversationId,
          },
          this.props.gid,
        );
        this.setState({ isError: true });
        return;
      }

      result = await req.json();
    } catch (error) {
      console.error("PAGE_VISIT_URL error:", error);
      trackAppInsightsEvent(
        "chat_page_load_failed",
        {
          reason: "network_or_exception",
          errorMessage: error && error.message ? error.message : String(error),
          vid: user.vid || "",
          sid: user.sid || "",
          botConversationId: botConversationId,
        },
        this.props.gid,
      );
      this.setState({ isError: true });
      return;
    }

    trackAppInsightsEvent(
      "chat_page_load_success",
      {
        iid: this.props.iid,
        pid: this.props.pid,
        botConversationId: botConversationId,
        vid: result && result.vid ? result.vid : "",
        sid: result && result.sid ? result.sid : "",
      },
      this.props.gid,
    );

    this.postMessage("chatbotConId:" + botConversationId);
    if (
      result &&
      result.vid !== undefined &&
      result.vid !== null &&
      result.vid !== "" &&
      result.sid !== undefined &&
      result.sid !== null &&
      result.sid !== ""
    ) {
      this.setState({ currencyCode: result?.currencyCode });
      fetch(GROUP_URL + "/" + this.props.gid, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((groupData) => {
          this.setState({ groupData });
        })
        .catch((error) => {
          console.error("Error fetching group data: ", error);
        });

      if (result && result.vid && result.sid) {
        if (this.props.previewMode == "false") {
          this.setState({ disabledChatbot: result.disabled });
        }
        if (result.disabled !== null && result.disabled === true) {
          this.postMessage("removeiframemode:");
        }

        if (user.sid !== result.sid) {
          localStorage.removeItem(this.state.lStore.BOTCLICK);
        }
        //Restrict Bot based upon the IP Address
        if (result.whiteListedIpAddresses?.length > 0) {
          if (
            result.whiteListedIpAddresses.find((x) => x === ip) === undefined
          ) {
            this.setState({ blockChatbot: true });
          }
        }

        localStorage.setItem(
          this.state.lStore.IDENTITY,
          JSON.stringify(result),
        );

        if (
          result.liveChatSettings !== undefined &&
          result.liveChatSettings.enabled === true &&
          result.liveChatSettings.provider == "1"
        ) {
          localStorage.setItem(
            this.state.lStore.ZENDESKGROUP,
            result.liveChatSettings.zendesk.departmentId,
          );
        }

        var localStorageLanguage = localStorage.getItem(
          this.state.lStore.LANGUAGE,
        );

        var lang = "";
        var userLang = navigator?.language || navigator?.userLanguage;

        if (
          userLang != undefined &&
          userLang != "" &&
          result.botSettings !== null &&
          result.botSettings.languages.length > 0 &&
          (this.props.language === undefined ||
            this.props.language === null ||
            this.props.language === "")
        ) {
          if (userLang.indexOf("-") > 0 && userLang.includes("en")) {
            //ENGLISH
            lang = "en";
          } else if (userLang === "zh-CN") {
            //SC
            if (
              result.botSettings.languages.filter((m) => m === "zh").length > 0
            ) {
              lang = "zh";
            }
          } else if (userLang === "zh-TW") {
            //TC
            if (
              result.botSettings.languages.filter((m) => m === "zh-TW").length >
              0
            ) {
              lang = "zh-TW";
            }
          } else {
            if (userLang.indexOf("-") > 0) {
              userLang = userLang.split("-")[0];
              if (
                result.botSettings.languages.filter((m) => m === userLang)
                  .length > 0
              ) {
                lang = userLang;
              }
            } else if (
              result.botSettings.languages.filter((m) => m === userLang)
                .length > 0
            ) {
              lang = userLang;
            }
          }
        }

        try {
          if (localStorageLanguage) {
            this.setState({
              vid: result.vid,
              sid: result.sid,
              lang: localStorageLanguage,
            });
          } else {
            this.setState({
              vid: result.vid,
              sid: result.sid,
              lang: lang === "" ? result.botSettings.defaultLanguage : lang,
            });
          }
        } catch (e) {
          this.setState({
            vid: result.vid,
            sid: result.sid,
            lang: lang === "" ? result.botSettings.defaultLanguage : lang,
          });
        }

        if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.level === "Group" &&
          result.properties.length > 1
        ) {
          this.state.bookingApp.open = true;

          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            },
          );

          var resultProperties = await reqProperties.json();

          const finalResult = [];
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                finalResult.push({
                  value: r.id,
                  label: r.name,
                  displayOrder: r.displayOrder,
                  domain:
                    r.domains != undefined &&
                    r.domains.length > 0 &&
                    r.domains.filter((m) => m.priority === 1).length > 0
                      ? r.domains.filter((m) => m.priority === 1)[0].type
                      : "",
                });
              }
            });
          });

          const sortfinalResult = finalResult.sort(
            this.dynamicSort("displayOrder"),
          );
          if (sortfinalResult.length > 0) {
            var property = localStorage.getItem(this.state.lStore.PROPERTYID);
            this.setState({ pid: property });
            var proid = property === null ? "-1" : property;
            if (property) {
              let obj = sortfinalResult.find((o) => o.value === property);
              this.state.bookingApp.selectedPid = obj;
            } else {
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });

              var groupData = await groupCall.json();
              //store groupData
              this.setState({ groupData });
              //If not group level domain setup
              if (groupData.group.domain === "") {
                this.state.bookingApp.selectedPid = sortfinalResult[0];
                this.setState({
                  pid: sortfinalResult[0].value,
                });
                localStorage.setItem(
                  this.state.lStore.PROPERTYID,
                  sortfinalResult[0].value,
                );
                localStorage.setItem(
                  this.state.lStore.DOMAIN,
                  sortfinalResult[0].domain,
                );
              }
            }

            try {
              var propertyName = localStorage.getItem(
                this.state.lStore.PROPERTYNAME,
              );
              if (propertyName) {
                let obj = sortfinalResult.find((o) => o.label === propertyName);
                localStorage.setItem(this.state.lStore.PROPERTYNAME, obj.label);
              } else {
                const groupCall = await fetch(
                  GROUP_URL + "/" + this.props.gid,
                  {
                    method: "GET",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  },
                );

                var groupData = await groupCall.json();
                //store groupData
                this.setState({ groupData });
                //If not group level domain setup
                if (groupData.group.domain === "") {
                  localStorage.setItem(
                    this.state.lStore.PROPERTYNAME,
                    sortfinalResult[0].label,
                  );
                }
              }
            } catch (e) {
              const groupCall = await fetch(GROUP_URL + "/" + this.props.gid, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              });

              var groupData = await groupCall.json();
              //store groupData
              this.setState({ groupData });
              if (groupData.group.domain === "") {
                localStorage.setItem(
                  this.state.lStore.PROPERTYNAME,
                  sortfinalResult[0].label,
                );
              }
            }
          }

          this.state.bookingApp.properties = sortfinalResult;
        } else if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.properties.length === 1
        ) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            },
          );

          var resultProperties = await reqProperties.json();
          result.properties.forEach((p) => {
            resultProperties.properties.forEach((r) => {
              if (p === r.id) {
                localStorage.setItem(this.state.lStore.PROPERTYNAME, r.name);
                localStorage.setItem(this.state.lStore.PROPERTYID, r.id);
                localStorage.setItem(
                  this.state.lStore.DOMAIN,
                  r.domains != undefined &&
                    r.domains.length > 0 &&
                    r.domains.filter((m) => m.priority === 1).length > 0
                    ? r.domains.filter((m) => m.priority === 1)[0].type
                    : "",
                );
                this.setState({ pid: r.id });
              }
            });
          });
        } else if (this.props.pid !== "" && this.props.pid !== undefined) {
          const reqProperties = await fetch(
            PROPERTIES_URL + "/" + this.props.gid,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            },
          );

          var resultProperties = await reqProperties.json();
          resultProperties.properties.forEach((r) => {
            if (this.props.pid === r.id) {
              localStorage.setItem(this.state.lStore.PROPERTYNAME, r.name);
              localStorage.setItem(this.state.lStore.PROPERTYID, r.id);
              localStorage.setItem(
                this.state.lStore.DOMAIN,
                r.domains != undefined &&
                  r.domains.length > 0 &&
                  r.domains.filter((m) => m.priority === 1).length > 0
                  ? r.domains.filter((m) => m.priority === 1)[0].type
                  : "",
              );
              this.setState({ pid: r.id });
            }
          });
        }
      }

      if (result.nudges) {
        this.setState({ nudges: result.nudges });
      }
      if (result.botSettings) {
        this.setState({ botSettings: result.botSettings });
      }
      if (result.liveChatSettings) {
        this.setState({ liveChatSettings: result.liveChatSettings });
      }
      if (result.persistentMenu) {
        let SideMenuItem = [];
        if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.level === "Group" &&
          result.properties.length > 1
        ) {
          SideMenuItem = [
            {
              type: "postback",
              title: "Switch Language",
              payLoad: "switch_language",
              url: "",
            },
            {
              type: "postback",
              title: "Switch Property",
              payLoad: "select_property",
              url: "",
            },
            {
              type: "postback",
              title: "Restart Chat",
              payLoad: "restart",
              url: "",
            },
            {
              type: "postback",
              title: "Hide Bot",
              payLoad: "hidebot",
              url: "",
            },
          ];
        } else if (
          (this.props.pid === "" || this.props.pid === undefined) &&
          result.properties.length === 1
        ) {
          SideMenuItem = [
            {
              type: "postback",
              title: "Switch Language",
              payLoad: "switch_language",
              url: "",
            },
            {
              type: "postback",
              title: "Restart Chat",
              payLoad: "restart",
              url: "",
            },
            {
              type: "postback",
              title: "Hide Bot",
              payLoad: "hidebot",
              url: "",
            },
          ];
        } else if (this.props.pid !== "" || this.props.pid !== undefined) {
          SideMenuItem = [
            {
              type: "postback",
              title: "Switch Language",
              payLoad: "switch_language",
              url: "",
            },
            {
              type: "postback",
              title: "Restart Chat",
              payLoad: "restart",
              url: "",
            },
            {
              type: "postback",
              title: "Hide Bot",
              payLoad: "hidebot",
              url: "",
            },
          ];
        }

        let MenuData = [];
        if (
          result.persistentMenu.menus.length > 0 &&
          result.persistentMenu.menuEnabled
        ) {
          result.persistentMenu.menus.map((item, index) => {
            let MenuDataItem = [];
            item.callToActions.map((menu) => {
              MenuDataItem.push({
                type: menu.type,
                title: menu.title,
                payLoad: menu.payLoad,
                url: menu.url,
              });
            });
            SideMenuItem.map((sideItem) => {
              MenuDataItem.push({
                type: sideItem.type,
                title: sideItem.title,
                payLoad: sideItem.payLoad,
                url: sideItem.url,
              });
            });

            MenuData.push({
              locale: item.locale,
              callToActions: MenuDataItem,
            });
          });
        } else {
          let MenuDataItem = [];
          SideMenuItem.map((sideItem) => {
            MenuDataItem.push({
              type: sideItem.type,
              title: sideItem.title,
              payLoad: sideItem.payLoad,
              url: sideItem.url,
            });
          });
          MenuData.push({
            locale: "default",
            callToActions: MenuDataItem,
          });
        }
        this.setState({
          persistentMenu: MenuData,
          persistentMenuEnabled: result.persistentMenu.menuEnabled,
        });
      }
      this.postMessage("messengerChatWindowOpened");
    }

    if (this.props.messengerId !== undefined && this.props.messengerId !== "") {
      await fetch(
        BMB_INTEGRATION +
          "/" +
          `${this.props.messengerId}?group_id=${this.props.gid}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((res) => res.json())
        .then(async (resultIntegration) => {
          //  console.log("Integration data: ", resultIntegration.botSettings);
          if (resultIntegration.botSettings) {
            var buttonColorsetting = {
              color: resultIntegration.botSettings.colours.buttonColor,
              backgroundColor:
                resultIntegration.botSettings?.colours?.botBackground,
              isFooterHide: resultIntegration.botSettings.isFooterHide,
              calendarButtonColor:
                resultIntegration.botSettings.calendarSetting.buttonColor,
              selectedButtonColor:
                resultIntegration.botSettings.calendarSetting
                  .selectedButtonColor,
              calendarTextColor:
                resultIntegration.botSettings.calendarSetting.buttonTextColor,
              selectedTextColor:
                resultIntegration.botSettings.calendarSetting
                  .selectedButtonTextColor,
              calendarLayout:
                resultIntegration.botSettings.calendarSetting.layout,
              widgetLayout: resultIntegration.botSettings.widgetLayout,
            };

            var micIconSetting = {
              isMicIcon: resultIntegration.botSettings.isMicIcon,
              micIconColor: resultIntegration.botSettings?.colours.micColor,
              micIcon: resultIntegration.botSettings.urls.micIcon,
              isBookNowButton: resultIntegration.botSettings.isBookNowButton,
              bookNowButtonText:
                resultIntegration.botSettings.bookNowButtonText,
              bookNowButtonUrl: resultIntegration.botSettings.bookNowButtonUrl,
              theme: resultIntegration?.botSettings?.theme,
              backgroundImage:
                resultIntegration?.botSettings?.suggestionBotSetting
                  ?.backgroundImage,
            };

            const botSettings = resultIntegration?.botSettings;
            // apply custom css safely to avoid crashing on malformed values
            try {
              const styleId = "bmb-custom-css";
              const existingStyle = document.getElementById(styleId);

              if (existingStyle) {
                existingStyle.remove();
              }

              if (
                botSettings?.customCss &&
                botSettings?.customCss?.isDisabled === false &&
                botSettings?.customCss?.text
              ) {
                const style = document.createElement("style");
                style.id = styleId;
                style.innerHTML = botSettings.customCss.text;

                document.head.appendChild(style);
              }
            } catch (customCssError) {
              console.error("Failed to apply custom CSS", customCssError);
            }

            const fontName = botSettings?.fonts?.website;

            const matchedFont = botSettings?.customFonts?.find(
              (f) => f.fontName === fontName,
            );

            const fontLink = matchedFont?.fontLink || "";

            this.setState({
              websiteFontName: fontName || "",
              websiteFontLink: fontLink,
            });

            this.setState({
              messengerSettings: buttonColorsetting,
              micIconSetting: micIconSetting,
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching integration data: ", err);
        });
    }

    return;
  }

  runNudges() {
    if (!this.state.nudges || this.state.opened || this.state.disabledChatbot) {
      return;
    }
    if (typeof Storage !== "undefined") {
      this.postMessage("totalnudges:" + this.state.nudges.length);
    }
    this.state.nudges.forEach((nudge) => {
      if (
        this.props.mobile === "true"
          ? !nudge.disabledInMobile
          : !nudge.disabledInDesktop
      ) {
        setTimeout(
          () => {
            if (
              nudge.eyeCatcher &&
              nudge.eyeCatcher.response &&
              nudge.eyeCatcher.response.messages
            ) {
              if (
                nudge.buttons !== null &&
                nudge.buttons !== undefined &&
                this.props.mobile == "false" &&
                nudge.buttons.length > 0
              ) {
                this.postMessage(
                  "nudgebutton:" +
                    JSON.stringify({
                      text: nudge.eyeCatcher.response.messages,
                      buttons: nudge.buttons,
                      botSettings: this.state.botSettings,
                    }),
                );
              } else {
                this.postMessage(
                  "eyecatcher:" +
                    JSON.stringify(nudge.eyeCatcher.response.messages),
                );
              }
            }
          },
          this.props.mobile === "true"
            ? nudge.delayInMillisecondsInMobile
            : nudge.delayInMilliseconds,
        );
      }
    });
  }

  /**
   * Posts a message to the parent window, if this window has one
   * @param {*} msg
   */
  postMessage(msg) {
    if (window.parent) {
      window.parent.postMessage(msg, "*");
    }
  }

  refresh() {
    new ChatWindowParticipantTagger().clearTags();
    localStorage.removeItem(this.state.lStore.CHAT_STATE);
    localStorage.removeItem(this.props.iid + "-chatfeedback");
    this.setState({
      extensions: {
        _api: ChatAppExtensions.getAPI(
          this,
          this.props,
          this.state.isSuggestBot,
        ),
      },
    });
    localStorage.removeItem(this.state.lStore.EXTENSIONS);
    this.state.chatBindings.showBookingForm(false, false);
    if (this.state.livechat) {
      this.state.livechat.closeChat();
      this.state.livechat.destroy();
      this.setState({
        inputEnabled: false,
        inLiveChat: false,
        started: false,
        inTwilioChat: false,
        twiliochat: undefined,
        livechat: undefined,
        loadingLivechat: false,
        agentName: undefined,
        getRoomTypes: undefined,
        inGenesysPureCloudChat: false,
        inAwsConnect: false,
        inMewsChat: false,
        store: getChatStore(this.state.chatBindings, true),
      });
    }
    localStorage.removeItem(this.state.lStore.CREDENTIALS);
    localStorage.removeItem(this.state.lStore.LIVECHAT_STARTED);
    localStorage.removeItem(this.state.lStore.MEWS_CHAT_STARTED);
    localStorage.removeItem(this.state.lStore.MEWS_THREAD);
    localStorage.removeItem(this.state.lStore.GENESYS_CLOUD_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_THREAD);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_REGION);
    localStorage.removeItem(this.state.lStore.PROPERTYID);
    localStorage.removeItem(this.state.lStore.PROPERTYNAME);
    localStorage.removeItem(this.state.lStore.LANGUAGE);
    localStorage.removeItem(this.state.lStore.LIVECHATCLIENT);
    localStorage.removeItem(this.state.lStore.BOTCLICK);
    localStorage.removeItem(this.state.lStore.LIVECHATMESSAGESTAMP);
    this.setState({
      getRoomTypes: undefined,
    });
    if (this.state.zendesk !== undefined) {
      this.state.zendesk.endChat();
    }
    this.setState({
      getRoomTypes: undefined,
      botSettings: undefined,
      inactivePopupOne: false,
      inactivePopupTwo: false,
      moveTop: false,
      inTwilioChat: false,
      twiliochat: undefined,
      twilioChatId: undefined,
      agentId: "",
      inZenDesk: false,
      zendesk: undefined,
    });
    this.closed();
    window.location.reload();
  }

  endGenesysPureCloud(textMessage) {
    fetch(`${process.env.REACT_APP_API_URL}/genesys/sendmessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.genesysPureCloudSettings.token,
        messageIntegrationId:
          this.state.genesysPureCloudSettings.messageIntegrationId,
        text: textMessage,
        from: {
          id: this.state.directline.conversationId,
          idType: "Opaque",
        },
      }),
    }).catch((err) => {
      console.error("Bmb livechat logging failed :(.");
      console.error(err);
    });
  }

  endAmazonConnect(textMessage) {
    fetch(
      `https://participant.connect.ap-southeast-2.amazonaws.com/participant/message`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Amz-Bearer":
            this.state.amazonConnectToken.ConnectionCredentials.ConnectionToken,
        },
        body: JSON.stringify({
          Content: textMessage, // The actual chat message
          ContentType: "text/plain", // Currently, supported type is text/plain
        }),
      },
    ).catch((err) => {
      console.error("Bmb livechat logging failed :(.");
      console.error(err);
    });

    fetch(
      `https://participant.connect.ap-southeast-2.amazonaws.com/participant/disconnect`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Amz-Bearer":
            this.state.amazonConnectToken.ConnectionCredentials.ConnectionToken,
        },
        body: JSON.stringify({}),
      },
    ).catch((err) => {
      console.error("Bmb livechat logging failed :(.");
      console.error(err);
    });
  }

  endMewsChat(textMessage) {
    let msg = [];
    if (
      this.state.mewsChatSettings !== undefined &&
      this.state.mewsChatSettings.Id !== undefined
    ) {
      msg.push({
        Text: textMessage,
        MessageThreadId: this.state.mewsChatSettings.Id,
        Identifier: "",
      });
    }
    if (msg.length > 0) {
      fetch(
        `${MEWS_API}/send-message?cid=${this.state.directline.conversationId}&iid=${this.props.iid}&gid=${this.props.gid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            msg: msg,
          }),
        },
      ).catch((err) => {
        console.error("Bmb livechat logging failed :(.");
        console.error(err);
      });
    }
  }
  /**
   * Deletes stored credentials and restarts
   */

  end() {
    new ChatWindowParticipantTagger().clearTags();
    localStorage.removeItem(this.state.lStore.CHAT_STATE);
    localStorage.removeItem(this.props.iid + "-chatfeedback");
    this.setState({
      extensions: {
        _api: ChatAppExtensions.getAPI(
          this,
          this.props,
          this.state.isSuggestBot,
        ),
      },
    });
    localStorage.removeItem(this.state.lStore.EXTENSIONS);
    this.state.chatBindings.showBookingForm(false, false);
    if (this.state.livechat) {
      this.state.livechat.closeChat();
      this.state.livechat.destroy();
      this.setState({
        inputEnabled: false,
        inLiveChat: false,
        started: false,
        livechat: undefined,
        loadingLivechat: false,
        agentName: undefined,
        getRoomTypes: undefined,
        moveTop: false,
        store: getChatStore(this.state.chatBindings, true),
      });
    }
    if (this.state.twiliochat) {
      this.state.twiliochat.sendMessage("The user has left the conversation.");

      fetch(TWILIO_END_CONVERSATION, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ twilioConversationId: this.state.twilioChatId }),
      }).then((res) => {});
      this.setState({
        inputEnabled: false,
        inTwilioChat: false,
        twiliochat: undefined,
        twilioChatId: undefined,
        started: false,
        livechat: undefined,
        loadingLivechat: false,
        agentName: undefined,
        getRoomTypes: undefined,
        store: getChatStore(this.state.chatBindings, true),
      });
    }
    if (this.state.signalrchat) {
      this.state.signalrchat.invoke("SendConversationMessageToAgent", {
        groupname: this.state.directline.conversationId,
        message: "The user has left the conversation.",
      });
      //this.state.signalrchat.stop();
      this.setState({
        inputEnabled: false,
        inSignalRChat: false,
        signalrchat: undefined,
        signalRChatId: undefined,
        started: false,
        livechat: undefined,
        loadingLivechat: false,
        agentName: undefined,
        getRoomTypes: undefined,
        store: getChatStore(this.state.chatBindings, true),
      });
    }

    if (this.state.inGenesysPureCloudChat) {
      this.endGenesysPureCloud("The user has left the conversation.");
      this.setState({ inGenesysPureCloudChat: false });
    }

    if (this.state.inAwsConnect) {
      this.endAmazonConnect("The user has left the conversation.");
      this.setState({ inAwsConnect: false });
    }

    localStorage.removeItem(this.state.lStore.CREDENTIALS);
    localStorage.removeItem(this.state.lStore.LIVECHAT_STARTED);
    localStorage.removeItem(this.state.lStore.GENESYS_CLOUD_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_THREAD);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_REGION);
    localStorage.removeItem(this.state.lStore.MEWS_CHAT_STARTED);
    localStorage.removeItem(this.state.lStore.MEWS_THREAD);
    // localStorage.removeItem(this.state.lStore.PROPERTYID);
    // localStorage.removeItem(this.state.lStore.PROPERTYNAME);
    // localStorage.removeItem(this.state.lStore.LANGUAGE);
    localStorage.removeItem(this.state.lStore.BOTCLICK);
    localStorage.removeItem(this.state.lStore.LIVECHATCLIENT);
    localStorage.removeItem(this.state.lStore.LIVECHATMESSAGESTAMP);
    this.setState({ directline: undefined, webSpeechPonyfill: undefined });
    this.setState({ botclick: false });

    if (this.state.zendesk !== undefined) {
      // zChat.un("connection_update", function (status) {console.log(status)});
      // zChat.un("chat", function (status) {console.log(status)});
      // this.state.zendesk.un("connection_update", function (status) {
      //   console.log(status);
      // });
      // this.state.zendesk.un("chat", function (detail) {
      //   console.log(detail);
      // });
      this.state.zendesk.endChat();
    }
    this.setState({
      getRoomTypes: undefined,
      botSettings: undefined,
      inactivePopupOne: false,
      inactivePopupTwo: false,
      moveTop: false,
      inTwilioChat: false,
      twiliochat: undefined,
      twilioChatId: undefined,
      agentId: "",
      inZenDesk: false,
      inMewsChat: false,
      openZChat_popup: false,
      open_ZChatfeedback_popup: false,
      property_popup: false,
      //zendesk: undefined,
    });
    // this.closed();
    setTimeout(() => {
      this.startConversation(false).then((m) => {
        this.recordClick();
      });
    }, 50);
  }

  endTwilio() {
    this.setState({
      inTwilioChat: false,
      twiliochat: undefined,
      twilioChatId: undefined,
      agentId: "",
    });
  }

  endSignalRChat() {
    this.state.signalrchat.stop();
    this.setState({
      inSignalRChat: false,
      signalrchat: undefined,
      signalRChatId: undefined,
      agentId: "",
    });
  }

  setAgentId(id) {
    this.setState({
      agentId: id,
    });
  }

  close_pop = () => {
    var getRoomTypes = this.state.getRoomTypes
      ? this.state.getRoomTypes
      : undefined;
    if (getRoomTypes) {
      getRoomTypes.reinit = false;
      this.setState({ getRoomTypes: getRoomTypes });
    }
  };

  async createSpeechRecognitionOnlyPonyfillFactory(
    fetchSpeechServicesCredentials,
  ) {
    const speechServicesPonyfillFactory =
      await window.WebChat.createCognitiveServicesSpeechServicesPonyfillFactory(
        {
          credentials: fetchSpeechServicesCredentials,
        },
      );

    return (options) => {
      const speechServicesPonyfill = speechServicesPonyfillFactory(options);

      return {
        SpeechGrammarList: speechServicesPonyfill.SpeechGrammarList,
        SpeechRecognition: speechServicesPonyfill.SpeechRecognition,
      };
    };
  }

  async speechConversation() {
    var pony = await fetch(`${process.env.REACT_APP_API_URL}/getSpeechToken`, {
      method: "POST",
    });
    var body = await pony.json();
    // console.log(body);
    if (pony.status === 200 && body && body.speechToken) {
      const speechServicesPonyfill =
        await this.createSpeechRecognitionOnlyPonyfillFactory({
          authorizationToken: body.speechToken,
          region: "eastus",
        });

      this.setState({
        webSpeechPonyfill: speechServicesPonyfill,
      });
    }
  }
  /**
   * Attempts to restore any stored chat, otherwise will fetch a new token and restart
   */
  async startConversation(createZchat) {
    // Existing token
    try {
      var stored = JSON.parse(
        localStorage.getItem(this.state.lStore.CREDENTIALS),
      );

      if (stored && stored.token && stored.uid) {
        this.setState({ user_id: stored.uid });

        // Attempt to refresh the token
        var msg = await fetch(MS_REFRESH_URL, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + stored.token,
          },
        });
        var body = await msg.json();

        if (msg.status === 200 && body && body.token) {
          // console.log("aaaaaa");

          this.setState({ directline: new DirectLine({ token: body.token }) });
          localStorage.setItem(
            this.state.lStore.CREDENTIALS,
            JSON.stringify({
              token: body.token,
              uid: stored.uid,
            }),
          );
          if (
            this.state.micIconSetting !== null &&
            this.state.micIconSetting !== undefined &&
            this.state.micIconSetting.isMicIcon === true &&
            this.state.webSpeechPonyfill === undefined
          ) {
            await this.speechConversation();
          }
          await this.registerPageLoad(body.conversationId);
          this.runNudges();

          // if (
          //   this.state.liveChatSettings !== undefined &&
          //   this.state.liveChatSettings.enabled === true &&
          //   this.state.liveChatSettings.provider == "1" &&
          //   createZchat === true
          // ) {
          //   var connection_status = zChat.getConnectionStatus();
          //   if (connection_status == "closed") {
          //     zChat.init({
          //       account_key: this.state.liveChatSettings.zendesk.accountKey,
          //     });
          //     if (
          //       localStorage.getItem(this.state.lStore.LIVECHAT_STARTED) ===
          //       "yes"
          //     ) {
          //       this.zenDeskFunctions(
          //         zChat,
          //         this.state.liveChatSettings.zendesk.departmentId
          //       );
          //     }
          //   }
          //   this.setState({
          //     zendesk: zChat,
          //     zendeskDepartment:
          //       this.state.liveChatSettings.zendesk.departmentId,
          //   });
          // } else if (
          //   this.state.liveChatSettings !== undefined &&
          //   this.state.liveChatSettings.enabled === true &&
          //   this.state.liveChatSettings.provider == "2"
          // ) {
          //   this.startGenesysPureCloudChat();
          // }
          // else if (
          //   this.state.liveChatSettings !== undefined &&
          //   this.state.liveChatSettings.enabled === true &&
          //   this.state.liveChatSettings.provider == "3"
          // ) {
          //   this.isMewsChatStarted();
          // }

          if (
            localStorage.getItem(this.state.lStore.AWS_CONNECT_STARTED) !==
              undefined &&
            localStorage.getItem(this.state.lStore.AWS_CONNECT_STARTED) ===
              "yes"
          ) {
            let status;
            fetch(
              `https://participant.connect.${localStorage.getItem(
                this.state.lStore.AWS_CONNECT_REGION,
              )}.amazonaws.com/participant/connection`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Amz-Bearer": localStorage.getItem(
                    this.state.lStore.AWS_CONNECT_THREAD,
                  ),
                },
                body: JSON.stringify({
                  ConnectParticipant: false,
                  Type: ["WEBSOCKET", "CONNECTION_CREDENTIALS"],
                }),
              },
            )
              .then((tokenresponse) => {
                status = tokenresponse.status;
                return tokenresponse.json();
              })
              .then((tokenJson) => {
                //console.log(tokenJson);
                // console.log(status);
                if (status === 200) {
                  this.setState({ inAwsConnect: true });
                  this.setState({ amazonConnectToken: tokenJson });
                  if (
                    localStorage.getItem(
                      this.state.lStore.AWS_CONNECT_STARTED,
                    ) !== "yes"
                  ) {
                    localStorage.setItem(
                      this.state.lStore.AWS_CONNECT_STARTED,
                      "yes",
                    );
                  }
                  const ws = new WebSocket(tokenJson.Websocket.Url); // Here, you use the websocket URL that you obtained from the response of CreateParticipantConnection API
                  const initialMessage = {
                    topic: "aws/subscribe",
                    content: {
                      topics: ["aws/chat"],
                    },
                  };

                  ws.addEventListener("open", () => {
                    ws.send(JSON.stringify(initialMessage));
                  });

                  ws.addEventListener("message", (event) => {
                    // process event here
                    // console.log(event.data);
                    const response = JSON.parse(event.data);
                    if (response.topic === "aws/chat") {
                      const responseMessage = JSON.parse(response.content);
                      if (responseMessage.Type === "MESSAGE") {
                        // display message in interface here
                        this.state.store.dispatch({
                          type: "AMAZONCONNECT/NEW_MESSAGE",
                          payload: responseMessage,
                        });
                      } else if (responseMessage.Type === "EVENT") {
                        if (
                          responseMessage.ContentType ===
                            "application/vnd.amazonaws.connect.event.typing" &&
                          responseMessage.ParticipantRole !== "CUSTOMER"
                        ) {
                          this.state.store.dispatch({
                            type: "TWILIO/TYPING",
                          });
                        } else if (
                          responseMessage.ContentType ===
                            "application/vnd.amazonaws.connect.event.participant.left" &&
                          responseMessage.ParticipantRole !== "CUSTOMER"
                        ) {
                          localStorage.removeItem(
                            this.state.lStore.AWS_CONNECT_STARTED,
                          );
                          localStorage.removeItem(
                            this.state.lStore.AWS_CONNECT_THREAD,
                          );
                          localStorage.removeItem(
                            this.state.lStore.AWS_CONNECT_REGION,
                          );
                          this.setState({ inAwsConnect: false });
                          this.state.store.dispatch({
                            type: "LIVECHAT/CHAT_END",
                            payload: "",
                          });
                        }
                      }
                    }
                  });
                } else {
                  localStorage.removeItem(
                    this.state.lStore.AWS_CONNECT_STARTED,
                  );
                  localStorage.removeItem(this.state.lStore.AWS_CONNECT_THREAD);
                  localStorage.removeItem(this.state.lStore.AWS_CONNECT_REGION);
                }
                // localStorage.setItem(
                //   this.state.lStore.AWS_CONNECT_THREAD,
                //   json.result.ContactId
                // );
              });
            // })
            // .catch((err) => {
            //   console.error("Bmb livechat logging failed :(.");
            //   console.error(err);
            // });
          }

          return; // QUIT FLOW if session succesfully recovered
        }
      }
    } catch {}

    // If session has expired/never existed
    //await this.speechConversation();

    if (this.props.openChatWindow === false) {
      this.closed();
    }
    this.setState({
      store: getChatStore(this.state.chatBindings, true),
      inputEnabled: false,
      inLiveChat: false,
      started: false,
      livechat: undefined,
      loadingLivechat: false,
      agentName: undefined,
      inGenesysPureCloudChat: false,
      inAwsConnect: false,
      inMewsChat: false,
    });

    localStorage.removeItem(this.state.lStore.LIVECHAT_STARTED);
    localStorage.removeItem(this.state.lStore.MEWS_CHAT_STARTED);
    localStorage.removeItem(this.state.lStore.GENESYS_CLOUD_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_STARTED);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_THREAD);
    localStorage.removeItem(this.state.lStore.AWS_CONNECT_REGION);
    const res = await fetch(TOKEN_GEN_URL, {
      method: "POST",
    });

    const data = await res.json();
    var token = data.directline.token;

    var uid = uuid();
    this.setState({ user_id: uid });
    // console.log("bbbb");
    this.setState({ directline: new DirectLine({ token: token }) });
    if (
      this.state.micIconSetting !== null &&
      this.state.micIconSetting !== undefined &&
      this.state.micIconSetting.isMicIcon === true &&
      this.state.webSpeechPonyfill === undefined
    ) {
      await this.speechConversation();
    }

    localStorage.setItem(
      this.state.lStore.CREDENTIALS,
      JSON.stringify({
        token,
        uid,
      }),
    );
    await this.registerPageLoad(data.directline.conversationId);
    this.runNudges();

    if (
      this.state.liveChatSettings !== undefined &&
      this.state.liveChatSettings.enabled === true &&
      this.state.liveChatSettings.provider == "1" &&
      createZchat === true
    ) {
      var connection_status = zChat.getConnectionStatus();

      if (connection_status == "closed") {
        zChat.init({
          account_key: this.state.liveChatSettings.zendesk.accountKey,
        });
      }
      this.setState({
        zendesk: zChat,
        zendeskDepartment: this.state.liveChatSettings.zendesk.departmentId,
      });
    }
  }

  startSignalRchat(conversationId, twilioConversionId) {
    const protocol = new JsonHubProtocol();
    const transport =
      HttpTransportType.WebSockets | HttpTransportType.LongPolling;
    const options = {
      transport,
      logMessageContent: true,
      logger: LogLevel.Error,
    };

    // create the connection instance
    const hubConnection = new HubConnectionBuilder()
      .withUrl(`${SIGNALR_URL}/api`, options)
      .withHubProtocol(protocol)
      .withAutomaticReconnect()
      .build();
    var uid = uuid();
    //startSignalRConnection(connection);
    hubConnection.start().then(() => {
      console.info("SignalR Connected");

      hubConnection
        .invoke("JoinConversation", {
          recipient: uid,
          groupname: conversationId,
        })
        .catch(function (err) {
          console.error(err.toString());
        });
      hubConnection.on("SignalRChatAgentMessage", (message) => {
        console.log("message to agent", message);
      });
      hubConnection.on("UserTyping", (message) => {
        console.log("user typing", message);
      });
      hubConnection.on("AgentTyping", (message) => {
        console.log("agent typing", message);
        this.state.store.dispatch({
          type: "SIGNALR/TYPING",
        });
      });
      hubConnection.on("SignalRChatUserMessage", (message) => {
        console.log("message to user", message);
        this.state.store.dispatch({
          type: "SIGNALR/NEW_MESSAGE",
          payload: message,
        });
      });

      this.setState({ inSignalRChat: true });
      this.setState({
        signalrchat: hubConnection,
      });
    });
  }

  startTwiliochat(conversationId, twilioConversionId) {
    if (this.state.twilioChatId === undefined) {
      this.setState({ inTwilioChat: true, twilioChatId: twilioConversionId });
      var identityBody = {
        identity: `${conversationId}_user`,
      };

      fetch(TWILIO_TOKEN_GEN_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(identityBody),
      }).then((tokenResponse) => {
        tokenResponse.json().then((twilioToken) => {
          this.setState({ twilioAccessToken: twilioToken.accessToken });
          ConversationsClient.create(twilioToken.accessToken).then(
            (twilioClient) => {
              twilioClient.on("conversationJoined", (conversation) => {
                this.setState({
                  twiliochat: conversation,
                });
                conversation.on("messageAdded", (msg) => {
                  this.state.store.dispatch({
                    type: "TWILIO/NEW_MESSAGE",
                    payload: msg.state,
                  });
                });
                conversation.on("typingStarted", (msg) => {
                  this.state.store.dispatch({
                    type: "TWILIO/TYPING",
                  });
                });
                // conversation.on("typingEnded", (msg) => {
                //   console.log("typingEnded")
                // });
              });
            },
          );
        });
      });
    }
  }

  setInTwiliochat(status) {
    this.setState({ inTwilioChat: status });
  }

  setInSignalRchat(status) {
    this.setState({ inSignalRChat: status });
  }

  isInTwiliochat() {
    return this.state.inTwilioChat;
  }

  isInSignalRchat() {
    return this.state.inSignalRChat;
  }

  sendTwilioTypingIndicator() {
    this.state.twiliochat.typing();
  }

  sendSignalRTypingIndicator() {
    this.state.signalrchat.invoke("UserTyping", {
      groupname: this.state.directline.conversationId,
      message: "typing",
    });
  }

  sendZendeskTypingIndicator() {
    this.state.zendesk.sendTyping(true);
  }

  zenDeskFunctions(zendesk, department) {
    this.setState({ inZenDesk: true });
    const self = this;
    localStorage.setItem(self.state.lStore.LIVECHAT_STARTED, "yes");
    if (
      localStorage.getItem(self.state.lStore.VISITORDETAILS) !== null &&
      localStorage.getItem(self.state.lStore.VISITORDETAILS) !== undefined
    ) {
      const preChat = JSON.parse(
        localStorage.getItem(self.state.lStore.VISITORDETAILS),
      );
      var visitorInfo = {
        display_name:
          preChat.name === ""
            ? preChat.firstName + " " + preChat.lastName
            : preChat.name,
      };
      if (preChat.email !== "") {
        visitorInfo.email = preChat.email;
      }
      if (preChat.phoneNumber !== "") {
        visitorInfo.phone = preChat.phoneNumber;
      }

      zendesk.setVisitorInfo(visitorInfo, function (err) {});
    }

    var newPage = {
      title: this.props.parent_title,
      url: this.props.parent_location,
    };

    zChat.sendVisitorPath(newPage, function (err) {});
    var zendeskDefaultDepartment = "";
    if (
      localStorage.getItem(self.state.lStore.ZENDESKGROUP) !== null &&
      localStorage.getItem(self.state.lStore.ZENDESKGROUP) !== undefined &&
      localStorage.getItem(self.state.lStore.ZENDESKGROUP) !== ""
    ) {
      zendeskDefaultDepartment = localStorage.getItem(
        self.state.lStore.ZENDESKGROUP,
      );
      const zendeskStartChat = setTimeout(() => {
        zendesk.setVisitorDefaultDepartment(
          parseInt(zendeskDefaultDepartment),
          (err) => {
            if (
              localStorage.getItem(self.state.lStore.LIVECHAT_STARTED) === "yes"
            ) {
              zendesk.sendChatMsg("bot:Resuming chat as page is refreshed");
            } else {
              sendHistoryToZendesk(self.state.store.getState(), zendesk);
              localStorage.setItem(self.state.lStore.LIVECHAT_STARTED, "yes");
            }
          },
        );
      }, 2000);
    } else {
      sendHistoryToZendesk(self.state.store.getState(), zendesk);
      localStorage.setItem(self.state.lStore.LIVECHAT_STARTED, "yes");
    }
    // if (department !== "") {
    //   zChat.setVisitorDefaultDepartment(parseInt(department));
    // }
    // sendHistoryToZendesk(self.state.store.getState(), zendesk);

    if (self.state.zendeskChatNew === true) {
      self.setState({ zendeskChatNew: false });
      zendesk.on("chat", function (detail) {
        if (detail.type === "chat.msg") {
          const agents = zendesk.getServingAgentsInfo();
          if (agents.length > 0 && self.state.inZenDesk === false) {
            self.setState({
              inZenDesk: true,
            });
            localStorage.setItem(self.state.lStore.LIVECHAT_STARTED, "yes");
          }
          if (detail.nick !== "visitor") {
            if (
              localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) ===
                null ||
              (localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) !==
                null &&
                parseInt(detail.timestamp) >=
                  parseInt(
                    localStorage.getItem(
                      self.state.lStore.LIVECHATMESSAGESTAMP,
                    ),
                  ))
            ) {
              self.state.store.dispatch({
                type: "ZENDESK/NEW_MESSAGE",
                payload: detail.msg,
              });
              localStorage.setItem(
                self.state.lStore.LIVECHATMESSAGESTAMP,
                detail.timestamp,
              );
            }
          }
        } else if (detail.type === "typing" && self.state.inZenDesk === true) {
          self.state.store.dispatch({
            type: "LIVECHAT/TYPING",
          });
        } else if (
          detail.type === "chat.memberjoin" &&
          self.state.inZenDesk === true
        ) {
          if (detail.nick !== "visitor") {
            if (
              localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) ===
                null ||
              (localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) !==
                null &&
                parseInt(detail.timestamp) >
                  parseInt(
                    localStorage.getItem(
                      self.state.lStore.LIVECHATMESSAGESTAMP,
                    ),
                  ))
            ) {
              self.state.store.dispatch({
                type: "ZENDESK/NEW_MESSAGE",
                payload:
                  "Agent " + detail.display_name + " has joined the chat",
              });
            }
          }
        } else if (
          detail.type === "chat.memberleave" &&
          self.state.inZenDesk === true
        ) {
          if (detail.nick !== "visitor") {
            if (
              localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) ===
                null ||
              (localStorage.getItem(self.state.lStore.LIVECHATMESSAGESTAMP) !==
                null &&
                parseInt(detail.timestamp) >
                  parseInt(
                    localStorage.getItem(
                      self.state.lStore.LIVECHATMESSAGESTAMP,
                    ),
                  ))
            ) {
              self.state.store.dispatch({
                type: "ZENDESK/NEW_MESSAGE",
                payload: "Agent " + detail.display_name + "  has left the chat",
              });
              const agents = zendesk.getServingAgentsInfo();
              if (agents.length === 0) {
                localStorage.removeItem(self.state.lStore.LIVECHAT_STARTED);
                self.setState({
                  inZenDesk: false,
                  open_ZChatfeedback_popup: true,
                });
              }
            }
          }
        } else if (
          detail.type === "chat.request.rating" &&
          self.state.inZenDesk === true
        ) {
          self.setState({
            open_ZChatfeedback_popup: true,
          });
        }
        if (
          detail.type === "chat.queue_position" &&
          self.state.inZenDesk === true
        ) {
          if (zChat.getQueuePosition() !== 0) {
            if (zChat.getQueuePosition() === 1) {
              self.state.store.dispatch({
                type: "ZENDESK/NEW_MESSAGE",
                payload: "You are next in queue now",
              });
            } else {
              self.state.store.dispatch({
                type: "ZENDESK/NEW_MESSAGE",
                payload: "Your position in queue is " + detail.queue_position,
              });
            }
          }
        }
      });
    }
    localStorage.setItem(this.state.lStore.LIVECHATCLIENT, zendesk);
    const myInterval = setInterval(function () {
      if (zChat.getQueuePosition() === 0) {
        clearInterval(myInterval);
      } else {
        clearInterval(myInterval);
        self.state.store.dispatch({
          type: "WEB_CHAT/SEND_EVENT",
          payload: {
            name: "agent_online_not_accepted",
          },
          value: {},
        });
        const myIntervalBusy = setInterval(function () {
          if (zChat.getQueuePosition() === 0) {
            clearInterval(myIntervalBusy);
          } else {
            clearInterval(myIntervalBusy);
            self.setState({ inZenDesk: false });
            self.state.store.dispatch({
              type: "WEB_CHAT/SEND_EVENT",
              payload: {
                name: "agent_online_busy",
              },
              value: {},
            });
          }
        }, 60 * 1000);
      }
    }, 20 * 1000);
  }

  startZenDeskChat() {
    const self = this;
    if (self.state.zendesk.getConnectionStatus() === "connected") {
      self.zenDeskFunctions(self.state.zendesk, self.state.zendeskDepartment);
    } else {
      self.state.zendesk.on("connection_update", function (status) {
        if (status === "connected") {
          this.zenDeskFunctions(
            self.state.zendesk,
            self.state.zendeskDepartment,
          );
        } else if (status === "closed") {
          //self.state.zendesk.reconnect();
        }
      });
    }
  }

  isMewsChatStarted() {
    let settings = localStorage.getItem(this.state.lStore.MEWS_THREAD);
    let isStarted = localStorage.getItem(this.state.lStore.MEWS_CHAT_STARTED);
    if (isStarted == true) {
      console.log(
        localStorage.getItem(this.state.lStore.MEWS_CHAT_STARTED),
        localStorage.getItem(this.state.lStore.MEWS_THREAD),
      );
      if (settings !== null && settings?.Id) {
        this.setState({ inMewsChat: true });
        this.setState({
          mewsChatSettings: settings,
        });
      }
    }
  }

  startMewsChat(json) {
    // console.log(json, json?.MessageThreads);
    this.setState({ inMewsChat: true });
    if (json?.MessageThreads && json?.MessageThreads.length > 0) {
      this.setState({
        mewsChatSettings: json.MessageThreads[0],
      });
      this.addThreadId(json?.MessageThreads[0]);
      localStorage.setItem(
        this.state.lStore.MEWS_THREAD,
        JSON.stringify(json.MessageThreads[0]),
      );
      var txt = `An agent has joined`;
      this.state.store.dispatch({
        type: "LIVECHAT/NEW_MESSAGE",
        payload: { text: txt },
      });
      if (localStorage.getItem(this.state.lStore.MEWS_CHAT_STARTED) !== "yes") {
        localStorage.setItem(this.state.lStore.MEWS_CHAT_STARTED, "yes");
      }
    }
  }

  startAWSConnectChat() {
    this.setState({ inAwsConnect: true });
    const history = getChatHistoryForAgent(this.state.store.getState());
    // console.log(history);
    fetch(
      `${process.env.REACT_APP_API_URL}/awsconnectchat?groupId=${
        this.props.gid
      }&propertyId=${localStorage.getItem(this.state.lStore.PROPERTYID)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: history,
          displayName: "CUSTOMER",
        }),
      },
    )
      .then((response) => response.json())
      .then((json) => {
        //console.log(json);

        fetch(
          `https://participant.connect.${json.region}.amazonaws.com/participant/connection`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Amz-Bearer": json.result.ParticipantToken,
            },
            body: JSON.stringify({
              ConnectParticipant: false,
              Type: ["WEBSOCKET", "CONNECTION_CREDENTIALS"],
            }),
          },
        )
          .then((tokenresponse) => tokenresponse.json())
          .then((tokenJson) => {
            //console.log(tokenJson);

            localStorage.setItem(
              this.state.lStore.AWS_CONNECT_THREAD,
              json.result.ParticipantToken,
            );

            localStorage.setItem(
              this.state.lStore.AWS_CONNECT_REGION,
              json.region,
            );

            this.setState({ amazonConnectToken: tokenJson });
            if (
              localStorage.getItem(this.state.lStore.AWS_CONNECT_STARTED) !==
              "yes"
            ) {
              localStorage.setItem(
                this.state.lStore.AWS_CONNECT_STARTED,
                "yes",
              );
            }
            const ws = new WebSocket(tokenJson.Websocket.Url); // Here, you use the websocket URL that you obtained from the response of CreateParticipantConnection API
            const initialMessage = {
              topic: "aws/subscribe",
              content: {
                topics: ["aws/chat"],
              },
            };

            ws.addEventListener("open", () => {
              ws.send(JSON.stringify(initialMessage));
            });

            ws.addEventListener("message", (event) => {
              // process event here
              // console.log(event.data);
              const response = JSON.parse(event.data);
              if (response.topic === "aws/chat") {
                const responseMessage = JSON.parse(response.content);
                if (responseMessage.Type === "MESSAGE") {
                  //  console.log("responseMessage", responseMessage);
                  // display message in interface here
                  this.state.store.dispatch({
                    type: "AMAZONCONNECT/NEW_MESSAGE",
                    payload: responseMessage,
                  });
                } else if (responseMessage.Type === "EVENT") {
                  if (
                    responseMessage.ContentType ===
                      "application/vnd.amazonaws.connect.event.typing" &&
                    responseMessage.ParticipantRole !== "CUSTOMER"
                  ) {
                    this.state.store.dispatch({
                      type: "TWILIO/TYPING",
                    });
                  } else if (
                    responseMessage.ContentType ===
                      "application/vnd.amazonaws.connect.event.participant.left" &&
                    responseMessage.ParticipantRole !== "CUSTOMER"
                  ) {
                    localStorage.removeItem(
                      this.state.lStore.AWS_CONNECT_STARTED,
                    );
                    localStorage.removeItem(
                      this.state.lStore.AWS_CONNECT_THREAD,
                    );
                    this.setState({ inAwsConnect: false });
                    this.state.store.dispatch({
                      type: "LIVECHAT/CHAT_END",
                      payload: "",
                    });
                  } else if (
                    responseMessage.ContentType ===
                      "application/vnd.amazonaws.connect.event.participant.joined" &&
                    responseMessage.ParticipantRole !== "CUSTOMER"
                  ) {
                    this.state.store.dispatch({
                      type: "AMAZONCONNECT/PLAIN_MESSAGE",
                      payload: `Agent ${responseMessage.DisplayName} has joined`,
                    });
                  }
                }
              }
            });
          });
      })
      .catch((err) => {
        console.error("Bmb livechat logging failed :(.");
        console.error(err);
      });
  }

  startGenesysPureCloudChat() {
    this.setState({ inGenesysPureCloudChat: true });

    fetch(
      `${process.env.REACT_APP_API_URL}/genesys/settings/${this.props.iid}?groupID=${this.props.gid}&propertyId=${this.props.pid}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((json) => {
        this.setState({
          genesysPureCloudSettings: json,
        });
        if (
          localStorage.getItem(this.state.lStore.GENESYS_CLOUD_STARTED) !==
          "yes"
        ) {
          localStorage.setItem(this.state.lStore.GENESYS_CLOUD_STARTED, "yes");

          sendHistoryToGenesysPureCloud(
            this.state.directline.conversationId,
            json.token,
            json.messageIntegrationId,
            this.state.store.getState(),
          );
        }
      })
      .catch((err) => {
        console.error("Bmb livechat logging failed :(.");
        console.error(err);
      });
  }

  /**
   * When called, starts the livechat session to replace the bot
   */
  startLivechat() {
    this.setState({ inLiveChat: true });
    // this.setState({ inLiveChat: true, loadingLivechat: true });
    this.setState({
      livechat: LivechatSDK.init({
        license: LIVECHAT_LICENSE,
        group: LIVECHAT_GROUP,
      }),
    });

    this.state.livechat.on("agent_changed", (agent) => {
      this.setState({ agentName: agent.name });
    });

    this.state.livechat.setVisitorData({
      name: "Book me Wallis",
      pageUrl: this.props.parent_location,
      pageTitle: this.props.parent_title,
      customProperties: {
        ReferringWebsite: this.props.parent_referrer,
        GroupID: this.props.gid,
        IntegrationID: this.props.iid,
        VisitorID: this.state.vid,
        SessionID: this.state.sid,
        ConversationID: this.state.directline.conversationId,
      },
    });

    // Register listeners, and send welcome message when ready
    this.state.livechat.on("ready", () => {
      // this.setState({ loadingLivechat: false });
      this.state.livechat.getPredictedAgent().then((agent) => {
        this.setState({ agentName: agent.name });
      });

      // Tell agent we are online and user that agent is connected
      if (localStorage.getItem(this.state.lStore.LIVECHAT_STARTED) !== "yes") {
        localStorage.setItem(this.state.lStore.LIVECHAT_STARTED, "yes");

        sendChatStore(this.state.store.getState(), this.state.livechat);

        this.state.livechat.sendMessage({
          text: "User requesting human transfer.",
          customId: String(Math.random()),
        });

        this.state.livechat.getPredictedAgent().then((agent) => {
          var txt = agent.name
            ? `Agent ${agent.name} has joined`
            : `An agent has joined`;
          this.state.store.dispatch({
            type: "LIVECHAT/NEW_MESSAGE",
            payload: { text: txt },
          });
        });
      }

      // Forward messages to directline
      this.state.livechat.on("new_message", (msg) => {
        this.state.store.dispatch({
          type: "LIVECHAT/NEW_MESSAGE",
          payload: msg,
        });
      });

      // Forward typing indicators to directline
      this.state.livechat.on("typing_indicator", () => {
        this.state.store.dispatch({
          type: "LIVECHAT/TYPING",
        });
      });

      // Fire end chat event
      this.state.livechat.on("chat_ended", (msg) => {
        this.state.store.dispatch({
          type: "LIVECHAT/CHAT_END",
          payload: msg,
        });
      });
    });
  }

  /**
   * Various setters/getters for children to take as props
   * Mostly used by the ChatStore.js
   */
  enableChat() {
    this.setState({ inputEnabled: true });
  }
  disableChat() {
    this.setState({ inputEnabled: false });
  }

  getState() {
    return this.state.store.getState();
  }
  getChatState() {
    return this.state;
  }

  setConnectionStatus(status) {
    if (
      status === ConnectionStatus.FailedToConnect ||
      status === ConnectionStatus.ExpiredToken ||
      status === ConnectionStatus.Ended
    ) {
      this.setState({ connectionError: true });
    } else {
      this.setState({ connectionError: false });
    }
  }

  setInactivePopupOne() {
    this.setState({ inactivePopupOne: true });
  }
  closeInactivePopupOne() {
    this.setState({ inactivePopupOne: false });
  }

  setInactivePopupTwo() {
    this.setState({ inactivePopupOne: false, inactivePopupTwo: true });
  }

  opened() {
    this.setState({ opened: true });
    this.postMessage("chatbotwindowOpen");
    localStorage.setItem(this.state.lStore.OPENED, "open");
    this.recordClick();
  }

  recordClick() {
    if (
      this.state.sid !== undefined &&
      this.state.botclick === false &&
      localStorage.getItem(this.state.lStore.BOTCLICK) !== "true"
    ) {
      const req = fetch(`${BOT_CLICKS}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          groupId: this.props.gid,
          sessionId: this.state.sid,
          integrationId: this.props.iid,
        }),
      });
      localStorage.setItem(this.state.lStore.BOTCLICK, "true");
      this.setState({ botclick: false });
    }
  }

  closed() {
    if (this.state.resize === true) {
      this.resize_actual();
    }
    this.postMessage("chatbotwindowClose");
    if (!this.props.defaultOpen) {
      this.setState({ opened: false });
      localStorage.removeItem(this.state.lStore.OPENED);
    }
    this.setState({ botclick: false });
    setTimeout(() => {
      this.runNudges();
    }, 1000);
  }

  hide_bot() {
    if (this.state.resize === true) {
      this.resize_actual();
    }
    this.postMessage("chatbotHide");
    setTimeout(() => {
      this.postMessage("chatbotwindowClose");
    }, 1000);
    this.setState({ opened: false });
    localStorage.removeItem(this.state.lStore.OPENED);
    setTimeout(() => {
      this.runNudges();
    }, 930000);
  }
  resize_full() {
    this.setState({ resize: true });
    this.postMessage("resizefull");
  }
  resize_actual() {
    this.setState({ resize: false });
    this.postMessage("resizeactual");
  }

  setInLivechat(status) {
    this.setState({ inLiveChat: status });
  }
  isInZendeskChat() {
    return this.state.inZenDesk;
  }
  isInLivechat() {
    return this.state.inLiveChat;
  }

  isInGenesysPureCloudChat() {
    return this.state.inGenesysPureCloudChat;
  }

  isInAWSConnectChat() {
    return this.state.inAwsConnect;
  }

  isInMewsChat() {
    return this.state.inMewsChat;
  }
  mewsChatSettings() {
    return this.state.mewsChatSettings;
  }

  genesysPureCloudChatSettings() {
    return this.state.genesysPureCloudSettings;
  }
  amazonConnectTokenSettings() {
    return this.state.amazonConnectToken;
  }

  hintClosed() {
    this.setState({ currentNudge: undefined });
  }

  sendFeedbackZenDeskChat(data, endChat) {
    const self = this;
    if (data.status === "send") {
      if (data.rate !== "") {
        zChat.sendChatRating(data.rate);
      }
      if (data.comments !== "") {
        zChat.sendChatComment(data.comments);
      }
    }
    self.setState({ open_ZChatfeedback_popup: false });
    if (endChat) {
      self.end();
    }
  }

  /**
   * Renders either the ChatWindow or the "ChatBubble" (bubble, pop up messages, etc visible when chat isn't)
   */
  render() {
    const {
      opened,
      directline,
      store,
      inputEnabled,
      user_id,
      loadingLivechat,
      agentName,
      currentNudge,
      makePayment,
      animation,
      botSettings,
      bookingApp,
      getRoomTypes,
      pid,
      blockChatbot,
      disabledChatbot,
      persistentMenu,
      persistentMenuEnabled,
      webSpeechPonyfill,
      micIconSetting,
      websiteFontName,
      websiteFontLink,
    } = this.state;
    const { mobile } = this.props;
    // console.log('logo', this.state.micIconSetting, this.state.lang)
    const theme = micIconSetting?.theme || "";
    const bgImage =
      (theme === "ChatSuggestions" || theme === "ChatSuggestionsFull") &&
      micIconSetting?.backgroundImage
        ? micIconSetting.backgroundImage
        : "";
    const intlLocaleKey = this.state.lang === "zh-TW" ? "hk" : this.state.lang;
    const currentAppLocale = AppLocale[intlLocaleKey] || AppLocale.en;
    const fallbackMessage = this.props.fallbackMessage
      ?.replace(/<[^>]*>/g, "")
      .trim();

    //console.log("render", this.props.AHData);

    return (
      <div>
        {this.state.isError && (
          <div className="error_window Window">
            <div className="errorcard ">
              {!fallbackMessage ? (
                <div className="ml-2 mr-2">
                  <span>
                    We're sorry, we're currently unavailable. <br />
                    Please visit our website, call us, or email us and we'll be
                    happy to assist.
                  </span>
                </div>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.props.fallbackMessage,
                  }}
                />
              )}
            </div>
          </div>
        )}
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <Fragment>
            <StartSalesforceChatSuccessModal
              isOpen={this.state.showTransferModal}
              caseNumber={this.state.transferCaseNumber}
              caseId={this.state.transferCaseId}
              buttonColor={this.state.messengerSettings?.color}
              onOk={() => this.setState({ showTransferModal: false })}
              gid={this.props.gid}
            />
            <CaseFormSuccessModal
              isOpen={this.state.showCaseFormSuccessModal}
              caseNumber={this.state.caseFormSuccessCaseNumber}
              caseId={this.state.caseFormSuccessCaseId}
              buttonColor={this.state.messengerSettings?.color}
              onOk={() => this.setState({ showCaseFormSuccessModal: false })}
              onClose={() => this.setState({ showCaseFormSuccessModal: false })}
              gid={this.props.gid}
            />
          </Fragment>
        </IntlProvider>
        {botSettings && !blockChatbot && persistentMenu ? (
          <Fragment>
            <ChatWindow
              opened={opened}
              pid={pid}
              onClosed={this.closed.bind(this)}
              directline={directline}
              webSpeechPonyfill={webSpeechPonyfill}
              store={store}
              inputEnabled={inputEnabled}
              user_id={user_id}
              endClicked={this.end.bind(this)}
              closeClicked={this.closeInactivePopupOne.bind(this)}
              loadingLivechat={loadingLivechat}
              agentName={agentName}
              bookingApp={bookingApp}
              card_app={makePayment}
              cookies_state_store={this.state.lStore.COOKIES}
              language_state_store={this.state.lStore.LANGUAGE}
              property_state_store={this.state.lStore.PROPERTYID}
              visitor_state_store={this.state.lStore.VISITORDETAILS}
              mobile={mobile}
              cookies_data={this.state.cookiesData}
              setBubbleToShrinkIn={() => {
                this.setState({
                  animation: { ...this.state.animation, bubbleToFadeIn: false },
                });
              }}
              botSettings={botSettings}
              room_app={getRoomTypes}
              close_pop={this.close_pop}
              isCheckedAvailability={this.state.isCheckedAvailability}
              hideRoomDetail={this.state.hideRoomDetail}
              customStyle={this.props.customStyle}
              refreshClicked={this.refresh.bind(this)}
              extensions={this.state.extensions}
              connectionError={this.state.connectionError}
              inactivePopupOne={this.state.inactivePopupOne}
              inactivePopupTwo={this.state.inactivePopupTwo}
              sid={this.state.sid}
              vid={this.state.vid}
              gid={this.props.gid}
              iid={this.props.iid}
              api={ChatAppExtensions.getAPI(
                this,
                this.props,
                this.state.isSuggestBot,
              )}
              hideTypingTextBox={this.hideTypingTextBox}
              lang={this.state.lang}
              moveTop={this.state.moveTop}
              persistentMenu={persistentMenu}
              persistentMenuEnabled={persistentMenuEnabled}
              inTwiliochat={this.state.inTwilioChat}
              messengerSettings={this.state.messengerSettings}
              resize={this.state.resize}
              resize_full={this.resize_full.bind(this)}
              resize_actual={this.resize_actual.bind(this)}
              hideBot={this.hide_bot.bind(this)}
              availblity={this.state.availblity}
              setAvailblity={this.setAvailblity.bind(this)}
              inZenDesk={this.state.inZenDesk}
              inAwsConnect={this.state.inAwsConnect}
              sendFeedbackZenDeskChat={this.sendFeedbackZenDeskChat.bind(this)}
              openZChat_popup={this.state.open_ZChatfeedback_popup}
              property_popup={this.state.property_popup}
              setPropertyPopUp={this.setPropertyPopUp.bind(this)}
              messenger={this.props.messenger}
              bot_restartClick={() => {
                this.setState({ bot_restart: false });
              }}
              bot_restart={this.state.bot_restart}
              autoDetect={this.state.autoDetect}
              bearerToken={this.state.bearerToken}
              currencyCode={this.state.currencyCode}
              groupData={this.state.groupData}
              isSuggestBot={this.state.isSuggestBot}
              isRestartcon={this.state.isRestartcon}
              restartIconclick={() => this.setState({ isRestartcon: false })}
              micIconSetting={this.state.micIconSetting}
              prechatdata={this.state.prechatdata}
              prechat_store={this.state.lStore.PERCHAT_FILL}
              imagedomain={this.props.imagedomain}
              messengerTheme={this.state.messengerTheme}
              parent_location={this.props.parent_location}
              bgImage={bgImage}
              theme={theme}
              websiteFontName={websiteFontName}
              websiteFontLink={websiteFontLink}
              accountId={this.props.accountId}
              contactId={this.props.contactId}
              propertyName={this.props.propertyName}
              userEmail={this.props.userEmail}
              userName={this.props.userName}
              userType={this.props.userType}
              businessName={this.props.businessName}
              chainName={this.props.chainName}
              AHData={this.props.AHData}
              onSalesforceTransferSuccess={({ caseId, caseNumber }) =>
                this.setState({
                  showTransferModal: true,
                  transferCaseId: caseId || "",
                  transferCaseNumber: caseNumber || "",
                })
              }
              onCaseFormSuccess={({ caseId, caseNumber }) =>
                this.setState({
                  showCaseFormSuccessModal: true,
                  caseFormSuccessCaseId: caseId || "",
                  caseFormSuccessCaseNumber: caseNumber || "",
                })
              }
            />
            {!opened &&
              !blockChatbot &&
              this.props.serviceview === false &&
              botSettings.bubbleSettings !== undefined &&
              botSettings.bubbleSettings !== null &&
              botSettings.bubbleSettings.bubbleType !== undefined &&
              botSettings.bubbleSettings.bubbleType !== null &&
              (botSettings.bubbleSettings.bubbleType === "Bubble" ? (
                <ChatBubble
                  onOpened={this.opened.bind(this)}
                  hintClosed={this.hintClosed.bind(this)}
                  currentNudge={currentNudge}
                  fadeIn={animation.bubbleToFadeIn}
                  botSettings={botSettings}
                  position={this.props.position}
                  mobile={mobile}
                  disabledChatbot={disabledChatbot}
                />
              ) : (
                <SildeBubble
                  onOpened={this.opened.bind(this)}
                  hintClosed={this.hintClosed.bind(this)}
                  currentNudge={currentNudge}
                  fadeIn={animation.bubbleToFadeIn}
                  botSettings={botSettings}
                  position={this.props.position}
                  mobile={mobile}
                  disabledChatbot={disabledChatbot}
                ></SildeBubble>
              ))}
          </Fragment>
        ) : (
          ""
        )}
        {blockChatbot ? (
          <p style={{ color: "white" }}>
            Access restricted: You need to be connected to the hotel's WiFi
            network to start chatting with the digital assistant. Please connect
            your device to the hotel's WiFi and try again.
          </p>
        ) : null}
      </div>
    );
  }
}
